import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, computed, makeObservable, reaction, runInAction } from "mobx";
import { AbstractPost, ClientModel } from "@devowl-wp/utils";
import { RootStore } from "../store/stores.js";
import { request } from "../utils/request.js";
class CookieModel extends AbstractPost {
    get templateModel() {
        return RootStore.get.cookieStore.templatesServices.get(this.data.meta?.presetId);
    }
    get rootStore() {
        return this.collection.store.collection.store.rootStore;
    }
    get technicalDefinitions() {
        return JSON.parse(this.data.meta.technicalDefinitions || "[]");
    }
    get googleConsentModeConsentTypes() {
        return JSON.parse(this.data.meta.googleConsentModeConsentTypes || "[]");
    }
    get dataProcessingInCountries() {
        return JSON.parse(this.data.meta.dataProcessingInCountries || "[]");
    }
    get dataProcessingInCountriesSpecialTreatments() {
        return JSON.parse(this.data.meta.dataProcessingInCountriesSpecialTreatments || "[]");
    }
    get isUpdateAvailable() {
        for (const { post_id } of this.rootStore.optionStore.templateNeedsUpdate){
            if (post_id === this.data.id) {
                return true;
            }
        }
        return false;
    }
    get codeDynamics() {
        return JSON.parse(this.data.meta.codeDynamics || "{}");
    }
    store;
    constructor(collection, data = {}){
        super(collection, data);
        makeObservable(this);
        reaction(()=>this.data?.usedTemplate, (template)=>runInAction(()=>{
                if (template) {
                    RootStore.get.cookieStore.addServiceTemplates([
                        template
                    ]);
                }
            }), {
            fireImmediately: true
        });
    }
    afterPatch() {
        // Remove this cookie from all other groups
        const groups = this.collection.store.collection;
        const [thisGroup] = this.data["rcb-cookie-group"];
        groups.entries.forEach((group)=>{
            if (thisGroup !== group.key) {
                group.cookies.entries.delete(this.key);
            } else {
                group.cookies.entries.set(this.key, this);
            }
        });
        this.rootStore.optionStore.fetchCurrentRevision();
        this.rootStore.cookieStore.unassignedCookies.delete(this.key);
    }
    setOrder(order) {
        this.data.menu_order = order;
    }
    setName(name) {
        this.data.title.raw = name;
    }
    setStatus(status) {
        this.data.status = status;
    }
    setPurpose(purpose) {
        this.data.content.raw = purpose;
    }
    setGroup(group) {
        this.data["rcb-cookie-group"] = [
            group
        ];
    }
    setMeta(meta) {
        this.data.meta = meta;
    }
    transformDataForPersist() {
        const data = super.transformDataForPersist();
        return {
            ...data,
            "rcb-cookie-group": [
                this.collection.store.key
            ]
        };
    }
    transformDataForPatch() {
        const data = super.transformDataForPatch();
        return {
            title: data.title,
            content: data.content,
            status: data.status,
            meta: data.meta,
            menu_order: data.menu_order,
            "rcb-cookie-group": this.data["rcb-cookie-group"],
            // Force to rewrite slug
            slug: data.title
        };
    }
    afterDelete() {
        this.collection.store.cookies.store.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterPersist() {
        const { optionStore, checklistStore } = this.collection.store.cookies.store.collection.store.rootStore;
        optionStore.fetchCurrentRevision();
        checklistStore.probablyFetchByChangedItem("add-cookie");
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "templateModel", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "rootStore", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Array),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "technicalDefinitions", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Array),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "googleConsentModeConsentTypes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Object),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "dataProcessingInCountries", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Object),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "dataProcessingInCountriesSpecialTreatments", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "isUpdateAvailable", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record),
    _ts_metadata("design:paramtypes", [])
], CookieModel.prototype, "codeDynamics", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "afterPatch", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Number
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setOrder", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setName", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PostStatus === "undefined" ? Object : PostStatus
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setStatus", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setPurpose", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Number
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setGroup", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieModel.prototype, "setMeta", null);
CookieModel = _ts_decorate([
    ClientModel.annotate({
        keyId: "id",
        namespace: "wp/v2",
        request,
        create: {
            path: "/rcb-cookie"
        },
        patch: {
            path: "/rcb-cookie/:id"
        },
        delete: {
            path: "/rcb-cookie/:id"
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof Partial === "undefined" ? Object : Partial
    ])
], CookieModel);
export { CookieModel };
